import React from 'react'
import { observer } from 'mobx-react-lite'
import { Redirect, useRouteMatch } from 'react-router-dom'

import { Box } from '@material-ui/core'

import { WbOrdersTabsScreen } from '../WbOrdersScreen'
import { OzonOrdersTabsScreen } from '../OzonOrdersScreen'
import { YandexMarketOrdersTabsScreen } from '../YandexMarketOrdersScreen'

import { useStore } from '../../hooks/storeHook'
import { useAccountParamsOptional } from '../../hooks/routeHooks'

import { appRoutes } from '../../common/appRoutes'

import { IntegrationType } from '../../server/mpsklad_core/Entity/IntegrationType'

export const OrdersRoute =
  observer(() => {
    const {integration} = useAccountParamsOptional()
    const isMsAccountOldRoute = !!useRouteMatch(appRoutes.MoySkladOld.orders.template)

    const {allowedIntegrations} = useStore()

    if (isMsAccountOldRoute && (!integration || integration === IntegrationType.MoySklad)) {
      return <Redirect to={appRoutes.MoySklad.orders}/>
    }

    if (!integration || !allowedIntegrations[integration]) {
      return null
    }

    return (
      <div className="body_wrapper_zero body_wrapper__home border_left" style={{minWidth: 'calc(100vw - 300px)'}}>
        <Box flex={1}>
          {
            allowedIntegrations[IntegrationType.Ozon] &&
            integration === IntegrationType.Ozon &&
            <OzonOrdersTabsScreen/>
          }

          {
            allowedIntegrations[IntegrationType.Wildberries] &&
            integration === IntegrationType.Wildberries &&
            <WbOrdersTabsScreen/>
          }

          {
            allowedIntegrations[IntegrationType.YandexMarket] &&
            integration === IntegrationType.YandexMarket &&
            <YandexMarketOrdersTabsScreen/>
          }
        </Box>
      </div>
    )
  })